import LayoutBasic from '../layouts/layoutBasic'
import { withRouter } from 'next/router'
import {GET} from '../helpers'
import {TOKEN, GET_USER_URL, CART} from '../vars'
import {setLocalKeyValue, getLocalKeyValue} from '../storage'

class TermsAndConditions extends React.Component{

  componentDidMount() {
    this.scrollToHash();
  }

  componentDidUpdate(prevProps) {
    const prevHash = prevProps.router?.asPath?.split('#')[1];
    const currentHash = this.props.router?.asPath?.split('#')[1];

    if (prevHash !== currentHash) {
      this.scrollToHash();
    }
  }

  scrollToHash = () => {
    if (typeof window === 'undefined') return;

    const hash = window.location.hash.replace('#', '');
    if (!hash) return;

    const target = document.getElementById(hash);
    if (!target) return;

    window.setTimeout(() => {
      const top = target.getBoundingClientRect().top + window.scrollY - 110;
      window.scrollTo({ top, behavior: 'smooth' });
    }, 120);
  };

      static async getInitialProps(props) {
        let token =  await process.browser ? getLocalKeyValue(TOKEN) : props.query.sec_token

        let infoRequest, infoResponse={}
        if(token) {
          try {
            infoRequest = await GET(GET_USER_URL, token)
            infoResponse = await infoRequest.data
          } catch (e) {

          }
        }

        return {
          token: token,
          user: infoResponse.user,
          cart: infoResponse.cart,
        }
      }

  render() {

    return <LayoutBasic title="Terms and Conditions" welcomenote_show="true" {...this.props}>
    <div className="licence container font-small my-5">
      <div className="row">
        <div className="col-sm-12">
          
          <h1 className="title mb-4">
          Terms and Conditions
          </h1>

          <p className="mb-3">
          <strong>Picxy Pro Technologies</strong><br />
          Registered Office: Visakhapatnam, Andhra Pradesh, India<br /> Last Updated: 24 July 2026
          </p>

          <h2 className="mt-4">1. Introduction</h2>

          <p>These Terms of Service ("Terms," "Agreement") govern the use of services offered by Picxy Pro Technologies ("Picxy," "we," "us," or "our") through the website and platform located at picxy.com (the "Platform"). By booking, purchasing, accessing, or otherwise using any service available on the Platform, you ("Client," "you," or "your") agree to be bound by these Terms.</p>

          <p>Picxy currently offers the following services through the Platform:</p>

          <ul>
          <li><strong>Photography &amp; Videography Booking Services</strong> – Booking professional photographers and videographers for events and commercial assignments.</li>
          <li><strong>AI Face Sync</strong> – AI-powered facial recognition technology that enables automated photo identification and personalized gallery access for event attendees.</li>
          <li><strong>Instashot</strong> – Professional instant reel creation, editing, and delivery services.</li>
          </ul>

          <p>These Terms apply to all Clients using any of the above services. Additional provisions in Section 6 apply specifically to photographers, videographers, and reel creators ("Contributors") engaged through the Platform.</p>



          <h2 className="mt-4">2. Photography &amp; Videography Booking Services</h2>

          <h3>2.1 Booking and Payment</h3>

          <p>A booking shall be confirmed only upon payment of 50% of the total service fee as an advance.</p>

          <p>The remaining 50% balance shall be payable upon completion of the event and prior to delivery of the final photographs and/or videographs.</p>

          <h3>2.2 Cancellation and Advance Payment</h3>

          <p>The advance payment is non-refundable under any circumstances.</p>

          <p>In the event of cancellation, Picxy may, at the Client's request:</p>

          <ul>
          <li>Reschedule the booking to another available date, subject to Contributor availability; or</li>
          <li>Adjust the advance payment against a future booking made by the same Client.</li>
          </ul>

          <p>No cash refund of the advance payment shall be issued.</p>

          <h3>2.3 Delivery</h3>

          <p>Final edited photographs and/or videographs shall be delivered only after receipt of the full outstanding payment.</p>

          <h2 className="mt-4">3. AI Face Sync Services</h2>

          <h3>3.1 Payment and Refund Policy</h3>

          <p>AI Face Sync services require 100% advance payment at the time of booking.</p>

          <p>If the event is cancelled by the Client before the commencement of services, Picxy shall provide a 100% refund of the amount paid.</p>

          <h3>3.2 Data Storage and Access</h3>

          <p>Facial recognition data and associated event photographs processed through AI Face Sync shall be securely stored by Picxy for one (1) year from the date of the event.</p>

          <p>Clients may extend storage and gallery access by purchasing an applicable extension package offered by Picxy.</p>

          <p>Upon expiry of the applicable storage period (including any extension), Picxy may archive or permanently delete facial recognition data and associated gallery information.</p>

          <p>For further information regarding the collection, processing, storage, and protection of personal data, please refer to Picxy's Privacy Policy.</p>

          <h2 className="mt-4">4. Instashot (Instant Reel Services)</h2>

          <h3>4.1 Pricing</h3>

          <p>Pricing for Instashot services is customized based on the Client's specific requirements and shall be communicated prior to booking confirmation.</p>

          <h3>4.2 Refunds</h3>

          <p>Once the assigned service has been completed, no refunds shall be provided.</p>

          <h3>4.3 Revisions</h3>

          <p>Picxy will provide reasonable re-editing of the delivered reel based on Client feedback, provided such revisions remain within the scope of the original creative brief.</p>

          <p>The first edit delivered to the Client will incorporate the instructions and feedback provided prior to or during production.</p>

          <p>Requests involving a substantially different creative direction may be treated as a new assignment and charged separately.</p>

          <h2 className="mt-4">5. Contributors – General Terms</h2>

          <p>Photographers, videographers, and reel creators engaged through the Platform are collectively referred to as "Contributors."</p>

          <h3>5.1 Engagement</h3>

          <p>Contributors are engaged by Picxy on an assignment-by-assignment basis to provide photography, videography, editing, or related services for Clients.</p>

          <p>Nothing contained in these Terms shall be construed as creating an employer-employee relationship unless otherwise agreed in writing.</p>

          <h3>5.2 Payout Terms</h3>

          <p>Contributor payouts shall be processed within 3–5 business days after:</p>

          <ul>
          <li>Completion of the assigned service; and</li>
          <li>Submission of a valid invoice.</li>
          </ul>

          <p>Payments shall be made exclusively through NEFT bank transfer to the Contributor's registered bank account.</p>

          <p>Payments through UPI or cash shall not be made.</p>

          <h3>5.3 Content Rights</h3>

          <p>Unless otherwise agreed in writing:</p>

          <ul>
          <li>Contributors retain ownership of their original copyrighted work.</li>
          <li>By accepting assignments through Picxy, Contributors grant Picxy a non-exclusive, worldwide, royalty-free license to use, reproduce, display, promote, market, distribute, and deliver the content for fulfilling Client bookings and promoting Picxy's services.</li>
          <li>Clients shall receive the usage rights agreed upon in their respective service agreement or quotation.</li>
          <li>Contributors may use the content in their professional portfolios unless restricted by Client confidentiality obligations or separate contractual agreements.</li>
          </ul>

          <h2 className="mt-4">6. General Provisions</h2>

          <h3>6.1 Modifications</h3>

          <p>Picxy reserves the right to modify these Terms at any time. Continued use of the Platform after such modifications constitutes acceptance of the revised Terms.</p>

          <h3>6.2 Limitation of Liability</h3>

          <p>To the maximum extent permitted by applicable law, Picxy shall not be liable for any indirect, incidental, consequential, special, or punitive damages arising out of or relating to the use of its services.</p>

          <p>Picxy's aggregate liability shall not exceed the amount paid by the Client for the specific service giving rise to the claim.</p>

          <h3>6.3 Force Majeure</h3>

          <p>Picxy shall not be liable for any delay or failure in performance resulting from circumstances beyond its reasonable control, including but not limited to natural disasters, pandemics, governmental actions, strikes, civil disturbances, technical failures, internet outages, or other force majeure events.</p>

          <h3>6.4 Privacy</h3>

          <p>Use of AI Face Sync and other Platform services may involve the processing of personal information.</p>

          <p>Such processing shall be governed by Picxy's Privacy Policy and applicable data protection laws.</p>

          <h3>6.5 Governing Law and Jurisdiction</h3>

          <p>These Terms shall be governed by and construed in accordance with the laws of India.</p>

          <p>Any disputes arising out of or relating to these Terms shall be subject to the exclusive jurisdiction of the competent courts at Visakhapatnam, Andhra Pradesh, India.</p>

          <h3>6.6 Severability</h3>

          <p>If any provision of these Terms is held to be invalid or unenforceable by a court of competent jurisdiction, the remaining provisions shall continue in full force and effect.</p>

          <h3>6.7 Contact Us</h3>

          <p>For any questions regarding these Terms or Picxy's services, please contact:</p>

          <hr className="my-4" />

          <h1 className="mt-4" id="StockImageLicensing" style={{ scrollMarginTop: '280px' }}>Notice Regarding Discontinuation of Stock Image Licensing Services</h1>

          <p>Picxy has made the strategic decision to discontinue its stock image licensing business as part of its transition towards providing photography services, AI-powered media solutions, photographer CRM, marketplace services, and related offerings. </p>

          <p>Accordingly, the following terms shall apply: </p>

          <h3>Service Transition </h3>

          <p>The stock image licensing service currently offered through Picxy will be gradually discontinued. During the transition period, certain features may be modified, restricted, or removed.</p>


          <h3>Existing Licensed Images </h3>

          <p>All licenses purchased prior to the effective date shall remain valid in accordance with the licensing terms applicable at the time of purchase. This transition does not revoke or alter rights previously granted to customers under valid licenses. </p>


          <h3>Photographer Content </h3>
          <p>Photographers who have contributed content to Picxy remain subject to the Contributor Agreement executed with Picxy. </p>

          <p>Picxy may contact contributors separately regarding future options relating to their portfolios, including migration, transfer, continued hosting, or removal of content, as applicable. </p>
          <p>Where applicable, contributors will receive separate communication outlining available options and any actions required from their end. </p>


          <h3>New Uploads </h3>
          <p>From the effective date announced by Picxy, new stock image submissions may no longer be accepted for licensing through the Picxy platform. </p>

          <h3>Transition to a Successor Platform </h3>
          <p>Picxy reserves the right to transfer, assign, migrate, or otherwise transition all or part of its stock image catalog, associated metadata, contributor information (subject to applicable agreements and privacy obligations), and related business assets to another organization as part of a merger, acquisition, asset sale, strategic partnership, or business restructuring. </p>
          <p>Should such a transition occur, contributors and customers will be notified where required by applicable law or contractual obligations. </p>


          <h3>Customer Support </h3>
          <p>During the transition period, Picxy will continue to provide reasonable support for existing licensing-related queries. </p>


          <h3>Updates </h3>
          <p>Picxy reserves the right to update this notice as additional information regarding the transition becomes available. </p>

          <h3>Business Transfer </h3>
          <p>In connection with any merger, acquisition, business transfer, asset sale, or strategic partnership, Picxy may transfer its stock image business, catalog, associated metadata, contributor agreements, customer records (subject to applicable privacy laws), and related operational assets to a successor organization. Such successor may continue operating, licensing, or managing the collection under its own policies, terms, and licensing framework. Any such transfer will not invalidate licenses already granted to customers prior to the transition. </p>


          <p>
          <strong>Picxy Pro Technologies</strong><br />
          📧 Email: <a href="mailto:support@picxy.com">support@picxy.com</a><br />
          📞 Phone: <a href="tel:+918885558235">+91 8885558235</a><br />
          🌐 Website: <a href="https://www.picxy.com" target="_blank" rel="noopener noreferrer">www.picxy.com</a>
          </p>

        </div>
      </div>
    </div>
    </LayoutBasic>
  }

}

export default withRouter(TermsAndConditions)
